
import makerjs from "makerjs";
function A49(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, W1 = Param[2].param,H1 = Param[3].param,W2 = Param[4].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w1 = W1 * 1 * myZoom,
       h1 = H1 * 1 * myZoom,
       w = W * 1 * myZoom,
       w2 = W2 * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = w-w2, x1 = 0, x2 = w-w1, x3 = w, y0 = 0, y1 = h, y2 = h1, y3 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (w1 !== 0) {
    var TxtW1 = W1;
} if (w2 !== 0) {
  var TxtW2 = W2;
} if (h1 !== 0) {
  var TxtH1 = H1;
}
   if (w !== 0) {
       var TxtW = W;
   }




   var drawAbnormalShapeA49 = {
    paths: {
     "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
     "TopLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
     "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
     "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
    }
};
var drawAbnormalShapeA49MarkH1 = {
    paths: {
     "LeftLine": new makerjs.paths.Line([x3, y3], [x3, y2]),
     "LeftShortUpline": new makerjs.paths.Line([x3, y2], [x3 + 2 * markShift, y2]),
     "LeftShortDnline": new makerjs.paths.Line([x3-markShift, y3], [x3 + 2 * markShift, y3]),
    }
};
var drawAbnormalShapeA49MarkW1 = {
    paths: {
     "UpLine": new makerjs.paths.Line([x2, y2], [x3, y2]),
     "UpShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
     "UpShortRTline": new makerjs.paths.Line([x3, y2], [x3, y2 + 2 * markShift]),
    }
};
var drawAbnormalShapeA49MarkH = {
    paths: {
     "RightLine": new makerjs.paths.Line([x1, y0], [x1, y1]),
     "RightShortUpline": new makerjs.paths.Line([x1+markShift, y0], [x1- 2 * markShift, y0]),
     "RightShortDnline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
    }
};
var drawAbnormalShapeA49MarkW = {
    paths: {
     "BottomLine": new makerjs.paths.Line([x1, y0-3* markShift], [x3, y0 -3* markShift]),
     "BotmShortLfline": new makerjs.paths.Line([x1, y0], [x1, y0 - 5 * markShift]),
     "BotmShortRTline": new makerjs.paths.Line([x3, y0], [x3, y0 - 5 * markShift]),
    }
};
var drawAbnormalShapeA49MarkW2 = {
    paths: {
     "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y0 - markShift]),
     "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2* markShift]),
     "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
    }
};
makerjs.model.addCaption(drawAbnormalShapeA49MarkW, TxtW, [x1, y0-4* markShift], [x3, y0 -4* markShift]);//长度文字  
makerjs.model.addCaption(drawAbnormalShapeA49MarkW1, TxtW1, [x2, y2 + 2*markShift], [x3, y2 + 2*markShift]);//长度文字 
makerjs.model.addCaption(drawAbnormalShapeA49MarkW2, TxtW2, [x0, y0 - 2*markShift], [x3, y0 - 2*markShift]);//长度文字
makerjs.model.addCaption(drawAbnormalShapeA49MarkH, TxtH,[x1- 2*markShift, y0], [x1- 2*markShift, y1]);//宽度文字
makerjs.model.addCaption(drawAbnormalShapeA49MarkH1, TxtH1, [x3 + 2*markShift, y3], [x3 + 2*markShift, y2]);//宽度文字

  plate={
    models: {
      drawAbnormalShapeA49: drawAbnormalShapeA49,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA49: drawAbnormalShapeA49,
        drawAbnormalShapeA49MarkW1: drawAbnormalShapeA49MarkW1,
        drawAbnormalShapeA49MarkH1: drawAbnormalShapeA49MarkH1,
        drawAbnormalShapeA49MarkH:drawAbnormalShapeA49MarkH,
        drawAbnormalShapeA49MarkW:drawAbnormalShapeA49MarkW,
        drawAbnormalShapeA49MarkW2:drawAbnormalShapeA49MarkW2
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A49;